import * as pcpQueries from '@/database/queries/pcps.queries'
import { chatsStore } from '@/store/chats/chats.store'
import { Pcp } from '@roolz/types/api/chats'

export async function addOrUpdatePcps(pcps: Pcp[]) {
  chatsStore.addOrUpdatePcps(pcps)
  await pcpQueries.addOrUpdatePcps(pcps)
}
